
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_1a1yw_93",
  "outline": "awsui_outline_4yi2u_1a1yw_129",
  "toggle-control": "awsui_toggle-control_4yi2u_1a1yw_151",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1a1yw_164",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1a1yw_167",
  "toggle-handle": "awsui_toggle-handle_4yi2u_1a1yw_174",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1a1yw_189",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1a1yw_192"
};
  